import React, {useState } from 'react';
import { SubmenuContainer } from './loadStopsInput';
import { AddButton, RemoveButton } from '../../content_management/reusableItems/buttons';
import { SelectField, OptionsContainer } from './inputFieldDelegate';
import { priceTypingProcess} from '../../../supplementary_components/priceInputDelegate';
import { generateShortId } from '../../../supplementary_components/supplementaryMethods';

export const ChargeOrFeeBlock = ({data, type, customProps})=> { 
    if(Array.isArray(data)){
        for (let i = 0; i<data.length;i++){
            if(typeof(data[i]) === 'string')data[i] = JSON.parse(data[i]);
            if(data[i].driver){
                if(!data[i]['driverName'] && data[i]['driverName'] !== ''){
                    data[i]['driverName'] = formatDriverData(data[i].driver)
                }
            }
        }
    }
    
    const [dataArray, setDataArray] = useState(data===''?[]:data);
    const [driverData, setDriverData] = useState(null);
    if(driverData === null){
        if(customProps && customProps.allPreviousTrucks){
            const executorsArray = [];
            for(const executor of customProps.allPreviousTrucks){
                if(executor['firstDriverId']){
                    executorsArray.push({id:executor['firstDriverId'], firstName:executor.firstDriverFirstName, lastName:executor.firstDriverLastName, currentTruckNumber: executor.truckNumber})
                }
                if(executor['secondDriverId']){
                    executorsArray.push({id:executor['secondDriverId'], firstName:executor.secondDriverFirstName, lastName:executor.secondDriverLastName, currentTruckNumber: executor.truckNumber})
                }
            }
            setDriverData({
                allPreviousTrucks: customProps && customProps.allPreviousTrucks ? customProps.allPreviousTrucks : null,
                displayValGenerator : (val)=>{
                    return `${val.firstName} ${val.lastName} (${val.currentTruckNumber})`
                },
                driverList : executorsArray
            });
        }
    }
    const updateSuggestionsList = (e, currentVal)=>{
        if(driverData){
            const array = [...driverData['driverList']];
            for (let i = 0; i < array.length;){
                if (!driverData.displayValGenerator(array[i]).toLowerCase().includes(currentVal.toLowerCase()) ){
                    array.splice(i, 1);
                }else{
                    i++;
                }
            }
            if(array.length > 0){
                e.target.nextSibling.style.display = 'block';
            }else{
                e.target.nextSibling.style.display = 'none';
            }
            
            changeFieldVal(e, "suggestionsList" , array, false);
        }
    }

    
    const structure = type === "driverChargesAndBonuses" ? ["desc",  "amount", "type"] : ["desc", "amount", "status"]
    const changeFieldVal = (e, fieldName, newVal, onBlur, removeErrorMessage)=>{
        const data = [...dataArray]
        const index = parseInt(e.target.parentElement.parentElement.getAttribute('data-index'));
        data[index][fieldName] = newVal;
        setDataArray(data);
        if(onBlur){
            if(e.target.className.includes('subError') ){
                if(e.target.value !== '' || removeErrorMessage){
                    e.target.className = e.target.className.replace('subError', '')
                }
            }
        }
    }
    
    return <SubmenuContainer  >
        {
            dataArray.map((value, index) => {
                const itemStatus = value.status || "pending";
                return <div key={index} id={`${type}Block`} data-index={index} className='noPadding'>
                    <span style={{gridTemplateColumns:type !== "driverChargesAndBonuses"?`1fr 0.66fr 0.8fr 1.0rem`:`1fr 1fr 0.66fr 7rem 1.0rem`}} data-index={index}>
                        { type === "driverChargesAndBonuses" ? 
                        <div >
                            <input name="id" hidden={true} defaultValue={value.id} />
                            <input name="status" hidden={true} defaultValue={itemStatus} />
                            <input name='driver' data-mandatory={true} 
                            disabled={itemStatus !== "pending"}
                            onFocus={(e)=>{
                                updateSuggestionsList(e, e.target.value.trim());
                            }}
                            onChange={(e)=>{
                                const currentVal = e.target.value.trim()
                                updateSuggestionsList(e, currentVal);
                                e.target.setAttribute('data-value', null)
                                changeFieldVal(e, 'driverName', currentVal);
                            }} 
                            onBlur={(e)=>{
                                
                                for (const child of e.target.nextSibling.childNodes[0].childNodes){
                                    if(child.matches(':hover')){
                                        e.target.setAttribute('data-value', child.getAttribute('data-raw-val'))
                                        changeFieldVal(e, 'driverName', formatDriverData(child.getAttribute('data-raw-val')), true, true);
                                    }
                                }
                                if(e.target.getAttribute('data-value') === 'null'){
                                    changeFieldVal(e, 'driverName', '');
                                }
                                
                                e.target.nextSibling.style.display = 'none';
                            }}
                            placeholder={"Driver"} value={value.driverName} data-value={JSON.stringify(value.driver)} /> 
                            <OptionsContainer id={'driverOptions'}  style={{display:'none'}} >
                                <div>
                                    {value['suggestionsList']?value['suggestionsList'].map((option, input)=>{
                                        return <div key={input} 
                                            data-raw-val={JSON.stringify(option)}>{driverData?driverData.displayValGenerator(option):'null'}
                                        </div>
                                    }):null}
                                </div>
                            </OptionsContainer>
                        </div>
                        
                        : null}

                        <input name={structure[0]} data-mandatory={true} 
                            disabled={type === "driverChargesAndBonuses" && itemStatus !== "pending"}
                            onChange={(e)=>{
                                changeFieldVal(e, structure[0], e.target.value)
                            }} 
                            onBlur={(e)=>{
                                changeFieldVal(e, structure[0], e.target.value, true)
                            }}
                            placeholder="Description" value={value[structure[0]]} />
                        <input name={structure[1]} data-mandatory={true} 
                            disabled={type === "driverChargesAndBonuses" && itemStatus !== "pending"}
                            onChange={(e)=>{
                                changeFieldVal(e, structure[1], e.target.value !== "" ? priceTypingProcess(e.target.value) : "")
                            }} 
                            onBlur={(e)=>{
                                changeFieldVal(e, structure[1], e.target.value !== "" ? priceTypingProcess(e.target.value) : "", true);
                            }} 
                            placeholder='Amount' value={value[structure[1]] !== "" ? priceTypingProcess(value[structure[1]]) : ""} />
                        
                        
                        

                        <SelectField name={structure[2]} value={value[structure[2]]} disabled={type === "driverChargesAndBonuses" && itemStatus !== "pending"} onChange={
                            (e)=>{
                                changeFieldVal(e, structure[2], e.target.value)
                            }}>
                            {type !== "driverChargesAndBonuses" ? <>
                            <option value={'charged'} >Charged</option> 
                            <option value={'reimbursed'} >Reimbursed</option>    
                            <option value={'notReimbursed'} >Not Reimbursed</option>  
                            </>
                            :
                            <>
                            <option value={'bonus'} >Bonus</option> 
                            <option value={'charge'} >Charge</option>    
                            </>
                        }  
                        </SelectField>
                        <RemoveButton disabled={type === "driverChargesAndBonuses" && itemStatus !== "pending"} action={
                            (e)=>{
                                dataArray.splice(parseInt(e.target.parentElement.parentElement.parentElement.getAttribute('data-index')), 1)
                                setDataArray([...dataArray]);
                            }}/>
                    </span>
                    
                </div>
            })
        }
        <div className="addButton removePadding">
            <AddButton customSize={"1.4rem"} inactive={driverData && driverData.driverList.length === 0 ? true : false}  action={()=>{
                setDataArray([...dataArray, type !== "driverChargesAndBonuses" ? 
                {driver:'', desc:'', amount: '', status: 'charged'} : {id: generateShortId(), driverName: "", driver:null, desc:'', amount: '', type: 'bonus', suggestionsList: []  }])
            }} />
        </div>
        
        
    </SubmenuContainer>
}

const formatDriverData = (val) => {
    if(val === null ) return '';
    const parsed = typeof(val) === 'string' ? JSON.parse(val) : val;
    return `${parsed.firstName} ${parsed.lastName}`
}
